export default ($http) => ({
  saveForLesson (lessonId, standardsIds) {
    return $http.put(`standards/lesson/${lessonId}`, { body: { standardsIds } })
  },
  deleteFromLesson (lessonId, standardId) {
    return $http.delete(`standards/lesson/${lessonId}/standard/${standardId}`)
  },
  getCoursesUnitsForAssessment (unitId) {
    return $http.get(`course-assessments/unit/${unitId}/standards`)
  },
  getInlineTrackingForLessonAssessment (lessonId) {
    return $http.get(`course-assessments/lesson/${lessonId}/standards`)
  },
  getSubjectAreas (query) {
    return $http.get('standards/content-areas', { query })
  },
  getBenchmarkLevels (subjectArea, query) {
    return $http.get(`standards/benchmark-levels/${subjectArea}`, { query })
  },
  getAllStrandsOptions (subjectArea, benchmarkLevel, query) {
    return $http.get(`standards/content-sub-area-levels/${subjectArea}/${benchmarkLevel}`, { query })
  },
  getStandards (subjectArea, benchmarkLevel, allStandards, query) {
    return $http.get(`standards/${subjectArea}/${benchmarkLevel}/${allStandards}`, { query })
  },
  getStandardsInlineTracking (courseId, query) {
    return $http.get(`standards/inline-standards-tracking/course/${courseId}`, { query })
  },
  getStandardsStatuses () {
    return $http.get('standards/status')
  },
  getOrderedStandardsForUnit(unitId) {
    return $http.get(`standards/unit/${unitId}/ordered`)
  },
  findStandardsByText(text) {
    return $http.post('standards/findByText', { body: { text } })
  },
  attachPastedStandards(selectedStandardIds, unitId, assessmentId, proficiencyId) {
    return $http.post('standards/attachPastedStandards', {
      body: {
        selectedStandardIds,
        unitId,
        assessmentId,
        proficiencyId
      }
    })
  },
  getOverviewDataForSingleStandard(standardId) {
    return $http.get(`standards/standards-overview/${standardId}`)
  },
  getStandardsOverviewData(query) {
    return $http.post('standards/standards-overview', { body: query, timeout: 90000 })
  }
})
